require('angular');		
require('angular-sanitize');
require('./videogular');

module.exports = 'com.2fdevs.videogular';



//////////////////
// WEBPACK FOOTER
// ./~/videogular/index.js
// module id = ./node_modules/videogular/index.js
// module chunks = 1